import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { ReportDeclaracaoSubstituicaoDiretorTecnicoPjRequest, ReportDeclaracaoSubstituicaoDiretorTecnicoPjResponse, ReportJobCreatedResponse, ReportJobStatusResponse } from './declaracao-substituicao-diretor-tecnico-pj.model';

/** Cliente HTTP do relatório assíncrono Declaração de Substituição de Diretor Técnico. */
@Injectable({ providedIn: 'root' })
export class DeclaracaoSubstituicaoDiretorTecnicoPjService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.prestador.reports.declaracaoSubstituicaoDiretorTecnicoPj;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    exportarPdf(request: ReportDeclaracaoSubstituicaoDiretorTecnicoPjRequest): Observable<HttpResponse<ReportDeclaracaoSubstituicaoDiretorTecnicoPjResponse | ReportJobCreatedResponse>> {
        return this.http.post<ReportDeclaracaoSubstituicaoDiretorTecnicoPjResponse | ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf`, request, { observe: 'response' });
    }

    iniciarGeracaoAssincrona(request: ReportDeclaracaoSubstituicaoDiretorTecnicoPjRequest): Observable<ReportJobCreatedResponse> {
        return this.http.post<ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf-async`, request);
    }

    consultarStatus(jobId: string): Observable<ReportJobStatusResponse> {
        return this.http.get<ReportJobStatusResponse>(`${this.PATH}/job/${jobId}/status`);
    }

    baixarPdf(jobId: string): Observable<ArrayBuffer> {
        return this.http.get(`${this.PATH}/job/${jobId}/download`, { responseType: 'arraybuffer' });
    }
}
